// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G1PTsnCNzhxOoZ {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: var(--ds-space-200, 16px);
  gap: var(--ds-space-100, 8px);
}
.pdAC3s2SVZsqmx {
  font-size: 12px;
  font-weight: var(--ds-font-weight-regular, normal);
}
`, ""]);
// Exports
export var title = `G1PTsnCNzhxOoZ`;
export var toggle = `pdAC3s2SVZsqmx`;
export default ___CSS_LOADER_EXPORT___;
